// extracted by mini-css-extract-plugin
export var carrierTab = "_3w-0";
export var carrierTabActive = "_3w-1 _3w-0";
export var carrierTabInactive = "_3w-2 _3w-0";
export var carrierTabLabel = "_3w-3";
export var carrierTabLabelActive = "_3w-4 _3w-3";
export var carrierTabLabelInactive = "_3w-5 _3w-3";
export var carrierTabPercentage = "_3w-6";
export var carrierTabPercentageActive = "_3w-7 _3w-6";
export var carrierTabPercentageInactive = "_3w-8 _3w-6";
export var carrierTabWinnable = "_3w-9";
export var carrierTabWinnableActive = "_3w-a _3w-9";
export var carrierTabWinnableInactive = "_3w-b _3w-9";
export var comparisonContainer = "_3w-d";
export var missingRateButton = "_3w-n";
export var missingRateButtonActive = "_3w-o _3w-n";
export var missingRateButtonInactive = "_3w-p _3w-n";
export var missingRateButtonLabel = "_3w-q";
export var missingRateButtonLabelActive = "_3w-r _3w-q";
export var missingRateButtonLabelInactive = "_3w-s _3w-q";
export var sidebar = "_3w-c";
export var strategyButton = "_3w-e";
export var strategyButtonActive = "_3w-f _3w-e";
export var strategyButtonDescription = "_3w-k";
export var strategyButtonDescriptionActive = "_3w-l _3w-k";
export var strategyButtonDescriptionInactive = "_3w-m _3w-k";
export var strategyButtonInactive = "_3w-g _3w-e";
export var strategyButtonLabel = "_3w-h";
export var strategyButtonLabelActive = "_3w-i _3w-h";
export var strategyButtonLabelInactive = "_3w-j _3w-h";
export var unitToggleButton = "_3w-t";
export var unitToggleButtonActive = "_3w-u _3w-t";
export var unitToggleButtonInactive = "_3w-v _3w-t";
export var unitToggleButtonLabel = "_3w-w";
export var unitToggleButtonLabelActive = "_3w-x _3w-w";
export var unitToggleButtonLabelInactive = "_3w-y _3w-w";